import React, { useEffect } from "react";
import "./App.css";
import { Navigate, Route, useLocation } from "react-router";
import RoutedPages from "Components/RouteDrawer/RoutedPages";
import { findRouteDrawer } from "Components/RouteDrawer/routeDrawers";
import { routeArray } from "Routes/route-config";
import { useAppDispatch } from "Redux/store";
import { useSelector } from "react-redux";
import { clear, getCookie, readObj, write } from "Service/storage";
import { getMe, restoreSession } from "Redux/Auth/reducers";
import { useAuthRedirect } from "Shared/Hook/use-auth";
import { selectAccount } from "Redux/Auth/slice";
import { ToastBlock } from "Components/Notify/notify";
import { ISSUES_ADD } from "Shared/Constants/routes";
import "react-calendar/dist/Calendar.css";
import { getPermissionList } from "Redux/Role/reducer";
import { selectDefaultRoute } from "Redux/Role/slice";
import { usePermissionsRedirect } from "Shared/Hook/use-permissions-redirect";
import { PageErrorBoundary } from "Components/ErrorBoundary/PageErrorBoundary";
import { Layout } from "Components/Layout/Layout";
function App() {
  const location = useLocation();
  const profile = useSelector(selectAccount);
  const defaultRoute = useSelector(selectDefaultRoute);
  const dispatch = useAppDispatch();
  // A crash in a page's own body, outside its Layout, still keeps the shell.
  const routes = routeArray.map((r) => (
    <Route
      key={r.path}
      path={r.path}
      element={
        <PageErrorBoundary
          renderFallback={(fallback) =>
            profile ? <Layout>{fallback}</Layout> : fallback
          }
        >
          <r.page />
        </PageErrorBoundary>
      }
    />
  ));

  const redirect = useAuthRedirect(location);
  useEffect(() => {
    const storedAccount = readObj("account");
    const cookieAccess = getCookie("access");
    const refresh = getCookie("refresh");
    if (cookieAccess && storedAccount?.token !== cookieAccess) {
      dispatch(getMe()).then((response) => {
        if (response.payload) {
          clear("account");
          write("account", {
            ...response.payload,
            token: cookieAccess,
            refresh: refresh,
          });
        }
      });
    }
  }, [dispatch]);
  useEffect(() => {
    if (location.pathname === "/") {
      window.location.replace(defaultRoute);
    }
  }, [location.pathname, defaultRoute]);

  useEffect(() => {
    if (profile) {
      dispatch(
        getPermissionList({
          refreshQuery: Date.now().toString(),
        })
      );
    }
  }, [profile]);

  usePermissionsRedirect();

  // Kept while the new-issue form is open (`/issues?new=1`, or the old
  // `/issues/add` URL on its way there).
  const issueFormOpen =
    location.pathname.startsWith(ISSUES_ADD) ||
    findRouteDrawer(location.pathname, location.search)?.formPath.startsWith(
      ISSUES_ADD,
    );
  if (!issueFormOpen) clear("issueFromFault");

  if (!profile) {
    const acc = readObj("account");
    if (acc) {
      setTimeout(() => {
        dispatch(restoreSession());
      }, 1000);
    }
  }

  if (redirect !== undefined) return <Navigate to={redirect} />;

  return (
    <>
      <ToastBlock />
      <RoutedPages routes={routes} />
    </>
  );
}

export default App;
